// 型と値の検証関数
export const validators = {
    isString: (value) => typeof value === 'string',
    isBoolean: (value) => typeof value === 'boolean',
    isObject: (value) => value !== null && typeof value === 'object' && !Array.isArray(value),
    
    // 設定値の検証
    theme: (value) => ['light', 'dark'].includes(value),
    nav: (value) => ['vertical', 'horizontal'].includes(value),
    layoutMode: (value) => ['fluid', 'boxed', 'detached'].includes(value),
    color: (value) => ['light', 'dark', 'brand'].includes(value),
    sidenavSize: (value) => ['default', 'condensed', 'compact', 'full', 'fullscreen', 'sm-hover'].includes(value),
    
    // オブジェクトの検証
    validateConfig: (config) => {
      if (!validators.isObject(config)) return false;
      return validators.theme(config.theme) &&
             validators.nav(config.nav) &&
             validators.layoutMode(config.layout?.mode) &&
             validators.color(config.topbar?.color) &&
             validators.color(config.menu?.color);
    }
  };